










import RoleServices from '@/services/role';
import { Vue, Component, ModelSync } from 'vue-property-decorator';
@Component
export default class KTagInput extends Vue {
  @ModelSync('value', 'change', { type: String })
  user!: string;

  roleSrv = new RoleServices();
  userList: any[] = [];

  onSelect(value: string) {
    this.user = value;
    let [userId, userName] = value.split('/');
    this.$emit('select', { userId, userName });
  }

  async handleSearch(value: string) {
    if (!value) return false;
    this.userList = await this.roleSrv.searchRoleUserList({ userId_like: value });
  }
}
